<template>
  <div class="volumes">
    <i class="fa fa-chevron-right"
       style="cursor: pointer; font-size: 18px;"
       @click="open"
    />
    <el-dialog title="Выбрать профессию" :visible.sync="isSelect" append-to-body
               width="400px">
      <div class="jobs-ul">
        <div
          class="jobs-li" v-for="(job, index) in list" :key="index" @click="add(job)"
        >
          <span>{{ job.name }}</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="Отчет по численности"
      append-to-body
      width="400px" :visible.sync="dialogObject">
      <div class="volumes">

        <div class="jobs-ul">
          <el-button size="small" class="add" type="primary" style="width: 100%; margin-bottom: 10px"
                     @click="isSelect = !isSelect">
            + Выбрать {{ tr[type] }}
          </el-button>
          <div style="display: flex; justify-content: flex-start">
          </div>
          <div class="jobs-li" v-for="(job, index) in result" :key="index">
            <div style="display: flex; justify-content: space-between; flex: 1; width: 100%">
              <div>
                <div class="flex" style="justify-content: flex-start; margin-bottom: 2px">
                  <strong>{{ job.name || job.label || (job.job && job.job.name) || '...' }}</strong>
                </div>
              </div>

              <div class="flex align">
                <div>
                </div>
                <i class="el-icon-close" style="margin-left: 10px;" @click="remove(index)"/>
              </div>
            </div>
            <el-row>

              <el-col :span="12">
                <el-input size="small" :placeholder="type === 'PROF' ? 'Чел' : 'Кол-во'" type="number"
                          v-model="job.value" @input="() => {
                 if(!job.time) {
                   job.time = timeProfGlobal.value
                 }
                }"/>
              </el-col>
              <el-col v-if="$store.state.project.available_reports.PROF_TIME" :span="12">
                <el-input size="small" placeholder="Часы" type="number" v-model="job.time"/>
              </el-col>
            </el-row>
          </div>

          <div style="margin-top: 20px" class="add-prof-filter">
            <filter-select

              v-model="form.work_type_dir"
              @input="() => form.work_type = null"
              v-if="$store.state.project.work_dir"
              :options="options_dirs" label="Раздел работ" style="margin-bottom: 0;"
            />
            <filter-select
              @input="selectWorkType"
              v-if="!$store.state.project.work_type_ignore" label="Вид работы"
              style="margin-bottom: 28px; margin-top: 0"
              :options="getWorks(form.work_type_dir)"
              v-model="form.work_type"/>

          </div>
        </div>
      </div>
      <div class="create-footer">
        <el-button @click="dialogObject = false">Закрыть</el-button>
        <el-button type="danger" v-if="result.length" @click="removeAll">Удалить</el-button>

        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import firebase from "firebase";
import {getCurrentMonth} from "../../../../utils/date";
import FilterSelect from "../../../../components/FilterSelect";
import {toFloat} from "../../../../utils/numberUtils";
import {getDirOptions} from "../../../../firestore/dirs";
import _, {orderBy} from "lodash";

export default {
  name: "AddProfTechToJob",
  components: {FilterSelect},
  props: {
    mainForm: [Array, Object],
    jobs: Array,
    workTypeOptions: {type: [Object, Array], default: () => ([])},
    jobName: "",
    table: {type: [Object, Array], default: () => ([])},
    type: String,
  },
  inject: ['timeProfGlobal'],
  data() {
    return {
      dialogObject: false,
      options_dirs: [],
      isSelect: false,
      result: [],
      list: [],
      form: {
        work_type: null,
        work_type_dir: null,
      },
      tr: {
        PROF: 'профессию',
        TECH: 'технику',
      },
      tra: {
        PROF: 'профессий',
        TECH: 'техники',
      },
    }
  },
  watch: {
    table: {
      deep: true,
      immediate: true,
      handler(table) {
        if (table && table.jobs) {
          this.form.work_type = table.work_type
          this.form.work_type_dir = table.work_type_dir

          this.result = [
            ...table.jobs
          ]

          this.selectWorkType()

        }
      }
    }
  },
  methods: {
    selectWorkType() {
      this.form.work_type_dir = this.options_dirs.find(({value}) => (this.form.work_type.dir && this.form.work_type.dir === value) || (this.form.work_type.data && (this.form.work_type.data.dir === value)))

    },
    open() {
      this.dialogObject = true


      if (this.mainForm && this.mainForm.work_type && !this.form.work_type) {
        this.form.work_type = this.workTypeOptions.find(({value}) => value === (this.mainForm.work_type))
      }

      this.selectWorkType()
    },
    getWorks(id) {
      if (!id || !id.value) {
        return this.workTypeOptions
      }

      return this.workTypeOptions.filter(({data}) => data.dir === id.value);
    },
    add(job) {
      this.result.push({
        ...job._data,
        plan: job._data.plan || '',
        value: '',
        time: '',
      });
      this.isSelect = false;
    },
    removeAll() {
      this.result = []
    },
    save() {

      let work_type = null;

      if (this.form.work_type) {
        work_type = {
          label: this.form.work_type.label,
          value: this.form.work_type.value,
          work_code: this.form.work_type.work_code || (this.form.work_type.data && this.form.work_type.data.work_code) || null,
          dir: this.form.work_type.dir || (this.form.work_type.data && this.form.work_type.data.dir) || null
        }
      }

      this.$emit('save', {
        jobs: [
          ...this.result.map((r) => {
            delete r.dataTotalValue
            delete r.ids_tech
            delete r.ids_prof
            delete r.project
            delete r.inputs
            delete r.volumes_prof
            delete r.permission
            delete r.volumes_tech
            delete r.volumes

            return r
          }),
        ],
        work_type: work_type,
        options_dirs: this.form.options_dirs,
        total: toFloat(this.total),
        value: toFloat(this.value),
        time: toFloat(this.time),
        cleanValue: toFloat(this.cleanValue.value),
        cleanTime: toFloat(this.cleanValue.time)
      })

      this.dialogObject = false;
    },
    remove(index) {
      const result = [...this.result];
      result.splice(index, 1)
      this.result = [...result];
    }
  },
  async mounted() {
    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).collection('jobs')
      .where('type', '==', this.type).get()
      .then((data) => {
        const result = []
        data.forEach((subDoc) => {
          const data = subDoc.data()
          result.push({
            name: data.name,
            plan: data.plan,
            id: subDoc.id,
            _data: data
          })
        })


        if (!this.result.length && this.type === 'PROF') {
          const worker = result.find((j) => j.name === 'Рабочие')
          if (this.$store.state.project.available_reports.PROF_ALL) {
            const resultJobs = orderBy(result, 'index', ['asc'])
            resultJobs.forEach((r) => {
              this.add(r)
            })

          } else if (worker) {
            this.add(worker)
          }
        }

        this.list = result;
      });

    this.options_dirs = await getDirOptions(this.$store.state.project.id);
  },
  computed: {
    total() {
      let result = 0;

      this.result.forEach(({plan}) => {
        result += plan || 0
      })

      return result
    },
    cleanValue() {
      let result = {
        value: 0,
        time: 0,
      }

      this.result.forEach((job) => {
        if (!(job.kind && job.kind.value === 'itr')) {
          result.value += Number(job.value || 0)
          result.time += Number(job.value || 0) * Number(job.time)
        }
      })

      return result
    },
    value() {
      let result = 0;

      this.result.forEach(({value}) => {
        result += Number(value || 0)
      })

      return result
    },
    time() {
      let result = 0;

      this.result.forEach(({time}) => {
        result += Number(time || 0)
      })

      return result
    },
    currentMonth() {
      return getCurrentMonth(this.$route.query.name)
    }
  }
}
</script>

<style scoped lang="scss">
.fa-edit {
  font-size: 18px;
  width: 100px;
}

.volumes {
  max-width: 95%;
  margin-left: 8px;
}

.create-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
}

.jobs-li {
  justify-content: center;
  min-height: 36px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  text-align: left;
  align-items: flex-start;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);

  &.pick {
    padding-bottom: 8px !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    align-items: center;
  }

  &:hover {
    background: #eee;
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>
<style lang="scss">
.volumes .el-dialog {
  max-width: 100% !important;
}

input::placeholder {
  color: #888 !important;
}

.add-prof-filter {
  .el-form-item {
    margin-bottom: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/AddProfTechToJob.vue